module.exports = __webpack_public_path__ + "static/media/Screen-Shot-2020-04-23-at-4.12.08-PM.82487ab0.png";